export default __webpack_public_path__ + "74989ec1e417cdecbf4a3606ea3493eb.png";